import { FC } from 'react';

import { YandexDirectReportType } from 'utils/constants/admin';

import { Text, VSpacing } from '@hh.ru/magritte-ui';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { DownloadButton } from 'components/Admin/YandexDirectReport/DownloadButton/DownloadButton';
import { OrdReportUploadField } from 'components/Admin/YandexDirectReport/OrdReport/OrdReportUploadField/OrdReportUploadField';

const ORD_REPORT_DOWNLOAD_URL = '/api/v1/backoffice/yandex_ord_report';

const TrlKeys = {
    title: 'admin.directReport.ord.title',
};

export const OrdReport: FC = () => {
    const [isUploaded, setIsUploadedOn, setIsUploadedOff] = useOnOffState(false);

    const trl = useTrls();

    return (
        <>
            <Text typography="title-4-semibold">{trl(TrlKeys.title)}</Text>
            <VSpacing default={24} />
            <OrdReportUploadField setIsUploadedOn={setIsUploadedOn} setIsUploadedOff={setIsUploadedOff} />
            {isUploaded && (
                <>
                    <VSpacing default={24} />
                    <DownloadButton reportType={YandexDirectReportType.ORD} downloadUrl={ORD_REPORT_DOWNLOAD_URL} />
                </>
            )}
        </>
    );
};
